module.exports = __webpack_public_path__ + "img/save2.e8135290.svg";